import {inject, Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {type V4BaseResponse} from './api-base.type';
import {ApiHttpClient} from './api-http.client';
import {PRIMARY_REGION_API_BASE_URL} from './api-base.type';

export interface SystemAppUpdateInfo {
  id?: string;
  name?: string;
  version?: string;
  min_version?: string;
  remark?: string;
  created_at?: string;
}

@Injectable({
  providedIn: 'root',
})
export class SystemApiService {
  private readonly apiHttp = inject(ApiHttpClient);

  async checkUpdate(): Promise<V4BaseResponse<SystemAppUpdateInfo>> {
    return this.apiHttp.postV4<SystemAppUpdateInfo>(
      `${PRIMARY_REGION_API_BASE_URL}/v4/system/check-update`,
      {app_id: environment.appId},
      {silentError: true},
    );
  }
}
